import React from "react";
import PageLayout from "../../components/PageLayout/PageLayout";
import ServicesSection from "./Sections/ServicesSection";
import { useLocation } from 'react-router-dom';

export default function ServicesPage(props) {
  const location = useLocation();
  const { configuration } = props;

  return (
    <PageLayout
      configuration={configuration}
      title="Dienstleistungen"
      helmetTitle="Dienstleistungen | Autowerkstatt Davos – Sportplatzgarage Gutknecht"
      description="Werkstattleistungen der Sportplatzgarage Gutknecht in Davos: Service, Diagnose, Zahnriemen, DSG, Bremsen und mehr – Fokus auf VW, Audi, SEAT, Škoda und CUPRA."
      path="/dienstleistungen"
    >
      <ServicesSection scrollTo={location.hash.substr(1)}/>
    </PageLayout>
  );
}
